const header = {
  headerText: {
    greetings: 'Halo',
    intro: 'Saya',
    preTitle: '',
  },
};

export default header;
